import EmblaCarousel from 'embla-carousel';
const imageCarousel = () => {
    const emblaNodes = document.querySelectorAll('.image-carousel');
    emblaNodes.forEach((node) => {
        const viewport = node.querySelector('.embla__viewport');
        const prevButton = node.querySelector('.embla__button--prev');
        const nextButton = node.querySelector('.embla__button--next');
        const options = {
            align: 'start',
            loop: true,
            draggable: true,
            slidesToScroll: 1,
        };
        const embla = EmblaCarousel(viewport, options);
        if (prevButton) {
            prevButton.addEventListener('click', () => embla.scrollPrev(), false);
        }
        if (nextButton) {
            nextButton.addEventListener('click', () => embla.scrollNext(), false);
        }
    });
};
export { imageCarousel };
